module.exports = __webpack_public_path__ + "img/Juan_Carlos.5b3354fb.png";